module.exports = __webpack_public_path__ + "static/img/icon.42ddd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/icon.png
// module id = UoSt
// module chunks = 44